import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CredentialsSection = () => {
  const academicHighlights = [
    {
      degree: "Bachelor of Technology in Computer Science",
      institution: "Ajay Kumar Garg Engineering College",
      year: "2022-2026",
      gpa: "8.09/10",
      honors: "",
      relevantCourses: [
        " Data Structures",
        "OOPS",
        "Database Management System",
        "Web technology",
        "Operating System",
        "Computer Networks "
      ]
    }
  ];

  const certifications = [
    {
      name: "AWS Certified Developer - Associate",
      issuer: "Amazon Web Services",
      date: "March 2024",
      credentialId: "AWS-DEV-2024-001",
      icon: "Cloud",
      color: "rocket-fire"
    },
    {
      name: "React Developer Certification",
      issuer: "Meta (Facebook)",
      date: "January 2024",
      credentialId: "META-REACT-2024-045",
      icon: "Code",
      color: "electric-cyan"
    },
    {
      name: "Google Analytics Certified",
      issuer: "Google",
      date: "December 2023",
      credentialId: "GOOGLE-GA-2023-789",
      icon: "BarChart3",
      color: "trust-green"
    },
    {
      name: "Scrum Master Certified",
      issuer: "Scrum Alliance",
      date: "November 2023",
      credentialId: "SA-CSM-2023-456",
      icon: "Users",
      color: "deep-space"
    }
  ];

  const achievements = [
    {
      title: "Dean\'s List Recognition",
      description: "Achieved Dean\'s List honors for 4 consecutive semesters",
      year: "2022-2024"
    },
    {
      title: "University Hackathon Winner",
      description: "1st place in annual coding competition with AI-powered solution",
      year: "2023"
    },
    {
      title: "Outstanding Student Award",
      description: "Computer Science Department\'s top graduate recognition",
      year: "2024"
    },
    {
      title: "Research Publication",
      description: "Co-authored paper on machine learning optimization techniques",
      year: "2024"
    }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white bg-gradient-to-br from-deep-space via-slate-900 to-slate-800">
      <div id="academics" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <Icon name="Award" size={24} className="text-rocket-fire" />
            <span className="text-rocket-fire font-medium">Credentials</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-headline text-deep-space mb-4 text-white">
            Academic Excellence & Professional Validation
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto text-grey">
            Formal education, industry certifications, and academic achievements that validate my technical expertise and commitment to excellence.
          </p>
        </div>

        {/* Academic Background */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-deep-space text-center mb-8 text-white">Academic Background</h3>
          {academicHighlights?.map((education, index) => (
            <div key={index} className="bg-gradient-to-br from-slate-50 to-slate-100 rounded-xl p-8 shadow-brand">
              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="lg:col-span-2">
                  <div className="flex items-start space-x-4 mb-6">
                    <div className="w-12 h-12 bg-deep-space/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <Icon name="GraduationCap" size={24} className="text-deep-space" />
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-deep-space mb-2">{education?.degree}</h4>
                      <p className="text-text-secondary mb-1">{education?.institution}</p>
                      <div className="flex flex-wrap gap-4 text-sm">
                        <span className="text-rocket-fire font-medium">Class of {education?.year}</span>
                        <span className="text-trust-green font-medium">GPA: {education?.gpa}</span>
                        <span className="text-electric-cyan font-medium">{education?.honors}</span>
                      </div>
                    </div>
                  </div>
                  
                  <div>
                    <h5 className="text-lg font-semibold text-deep-space mb-4">Relevant Coursework</h5>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                      {education?.relevantCourses?.map((course, idx) => (
                        <div key={idx} className="flex items-center space-x-2">
                          <Icon name="CheckCircle" size={16} className="text-trust-green flex-shrink-0" />
                          <span className="text-text-primary text-sm">{course}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                
                <div className="flex flex-col justify-center items-center text-center">
                  <div className="w-24 h-24 bg-deep-space/10 rounded-full flex items-center justify-center mb-4">
                    <Icon name="Trophy" size={32} className="text-deep-space" />
                  </div>
                  <div className="text-3xl font-bold text-deep-space mb-2">{education?.gpa?.split('/')?.[0]}</div>
                  <div className="text-sm text-text-secondary">Cumulative GPA</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        

        

        
      </div>
    </section>
  );
};

export default CredentialsSection;